import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  container: {
    width: '100%',
    borderRadius: 8,
    cursor: 'pointer',
    padding: '20px 0',
    textAlign: 'center',
    textTransform: 'none',
    border: `1px dashed ${theme.palette.background.medium}`,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.background.light,
    },
  },
  label: {
    fontSize: 14,
    fontWeight: 400,
  },
})

const EmptyStateButton = ({
  classes, className, label, onPress 
}) => (
  <Button
    classes={{ label: classes.label }}
    className={classNames(className, classes.container)}
    onClick={onPress}>
    <Typography>{label}</Typography>
  </Button>
)

EmptyStateButton.propTypes = {
  label: PropTypes.string,
  onPress: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(EmptyStateButton)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/EmptyStateButton.js